module.exports = __webpack_public_path__ + "img/app_tiny.693e2434.png";